import Moment from 'moment';

/**
 * Regra de vencimento de contrato, usada na lista e no card do Kanban.
 *
 * Estava só na ListaPage; o card do Kanban precisa da mesma leitura ("Vencido",
 * "Vence hoje", "12d") e da mesma faixa de severidade. Duas cópias divergiriam
 * na primeira vez que alguém mexesse numa das faixas.
 */
const dias = (valor) => {
    if (!valor) return null;
    return Moment(valor).startOf('day').diff(Moment().startOf('day'), 'days');
};

export default {
    dias,

    data(valor) {
        return valor ? Moment.utc(valor).format('DD/MM/YYYY') : '';
    },

    rotulo(valor) {
        const d = dias(valor);
        if (d === null) return '';
        if (d < 0) return 'Vencido';
        if (d === 0) return 'Vence hoje';
        return `${d}d`;
    },

    severidade(valor) {
        const d = dias(valor);
        if (d === null) return 'secondary';
        if (d <= 15) return 'danger';
        if (d <= 30) return 'warn';
        return 'info';
    },
};
